import { useState } from 'react'
import { Button } from '../../../../../common/html/button'
import { PayNowButton } from '../../PayNowButton'
import { PopupQuotation } from '../../popupQuotation'

export const GroupButton = ({
  subscriptionDetails,
  isBuyPackage,
  isDisableGroupBtn,
  buyNow,
  userProfile,
  loadingUserProfile,
  updateSubscriptionDetailsParams,
}) => {
  const [isOpenQuotation, setIsOpenQuotation] = useState(false)

  const getQuotation = () => {
    setIsOpenQuotation(true)
    updateSubscriptionDetailsParams()
  }

  return (
    <>
      <div className="dFlex justifyContentEnd">
        <Button
          label="userManagement.buyPackage.GET_QUOTATION"
          style={{
            border: 'none',
            backgroundColor: '#2C73E8',
            color: '#FFFFFF',
            padding: '6px 12px',
            borderRadius: '4px',
            width: 120,
            fontSize: 12,
            marginRight: 8,
            cursor: 'pointer',
            opacity: isDisableGroupBtn ? 0.6 : 'unset',
          }}
          action={!isDisableGroupBtn ? getQuotation : () => {}}
          isI18n
        />
        <PayNowButton
          onClick={buyNow}
          title="userManagement.paymentInformation.CHECKOUT"
          disabled={isDisableGroupBtn}
        />
      </div>
      <PopupQuotation
        isShow={isOpenQuotation}
        setIsShow={setIsOpenQuotation}
        subscriptionDetails={subscriptionDetails}
        isBuyPackage={isBuyPackage}
        userProfile={userProfile}
        loadingUserProfile={loadingUserProfile}
      />
    </>
  )
}
